export const extract = (object, props = []) => {
  const results = {}
  props.forEach(prop => {
    if (object[prop] !== undefined) {
      results[prop] = object[prop]
    }
  })
  return results
}

// https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
export const isObject = (obj) => typeof obj === 'object' && obj !== null

// https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
export const isObjectEmpty = (value) => value === undefined || value === null || Object.keys(value).length === 0

// https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
export const deepClone = (obj) => obj !== undefined && obj !== null ? JSON.parse(JSON.stringify(obj)) : undefined

// TODO: check this with different browser
export const cleanUndefined = deepClone

export const safeDeepUpdate = (obj, path = [], value) => {
  if (obj === undefined || obj === null || path === undefined || path === null || path.length === 0) return
  const lastKey = path.pop()
  const loc = path.reduce((acc, cur) => {
    if (acc[cur] === undefined || acc[cur] === null) {
      acc[cur] = {}
    }
    return acc[cur]
  }, obj)
  loc[lastKey] = typeof value === 'function' ? value(loc[lastKey]) : value
}

export const objectIterator = (obj, cb) => Object.keys(obj || {}).map((key) => cb(obj[key], key))

export const shallowEqual = (obj1 = {}, obj2 = {}, keys) =>
  Array.isArray(keys)
    ? keys.find((key) => obj1[key] !== obj2[key]) === undefined
    : Object.keys(obj1).find((key) => obj1[key] !== obj2[key]) === undefined && Object.keys(obj2).find((key) => obj1[key] !== obj2[key]) === undefined
